import { ThumbnailSize } from "../components/Thumbnail";
import { coreService } from "../services/coreService";
import { fetch } from "../lib/network";
import { buildQuery } from "../lib/network";

export const getThumbnail = (networkHeaders: any) => (uuid: string, size: ThumbnailSize) => {
  return buildQuery(coreService.fileThumbnailDetail(uuid, size, { headers: networkHeaders }), (response) => {
    return response.data;
  });
};

export enum VideoStatus {
  Pending = "Pending",
  Running = "Running",
  Complete = "Complete",
  Error = "Error",
}
export const getVideo = (networkHeaders: any) => (uuid: string) => {
  return buildQuery(coreService.fileVideoDetail(uuid, { headers: networkHeaders }), (response) => {
    return response.data;
  });
};

export const fetchVideo = async (url: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch video: ${response.statusText}`);
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};
